import { apiGet, apiPost, apiPut } from './client';
import { ApiResponse, Endorsement } from '@tinyrewards/shared';


export interface PendingEndorsementRow {
    EndorsementID: string;
    BadgeID: string;
    BadgeName: string;
    BadgeImage: string | null;
    EndorserName: string;
    EndorserOrganization: string | null;
    EndorsementText: string;
    DateCreated: string;
    IsApproved: boolean;
}

export interface ApprovedEndorsement {
    endorsementID: string;
    badgeID: string;
    badgeName: string;
    badgeImage: string | null;
    endorserUserID: string;
    endorserName: string;
    endorserOrganization?: string;
    endorsementText: string;
    dateCreated: string;
    isApproved: boolean;
}

export interface PendingBadgeRow {
    ID: string;
    OpenBadgeID: string;
    BadgeName: string;
    BadgeDescription: string | null;
    Image: string | null;
    CreatedDateTime: string;
    ExpiresON: string | null;
}

export type PendingListResponse<T> = ApiResponse<T[]> & {
    total: number;
    page: number;
    pageSize: number;
};

export function listAllEndorsements(): Promise<ApiResponse<ApprovedEndorsement[]>> {
    return apiGet<ApprovedEndorsement[]>('/api/endorsements');
}

export function listPendingSent(page = 1): Promise<PendingListResponse<PendingEndorsementRow>> {
    return apiGet<PendingEndorsementRow[]>(`/api/endorsements/pending/sent?page=${page}`) as Promise<
        PendingListResponse<PendingEndorsementRow>
    >;
}

export function listPendingReceived(page = 1): Promise<PendingListResponse<PendingEndorsementRow>> {
    return apiGet<PendingEndorsementRow[]>(`/api/endorsements/pending/received?page=${page}`) as Promise<
        PendingListResponse<PendingEndorsementRow>
    >;
}

export function listPendingBadges(page = 1): Promise<PendingListResponse<PendingBadgeRow>> {
    return apiGet<PendingBadgeRow[]>(`/api/endorsements/pending-badges?page=${page}`) as Promise<
        PendingListResponse<PendingBadgeRow>
    >;
}

export function approveEndorsement(
    endorsementID: string,
    payload: { endorsementText: string; endorserName: string; endorserOrganization?: string },
): Promise<ApiResponse<Endorsement>> {
    return apiPut<Endorsement>(`/api/endorsements/${endorsementID}/approve`, payload);
}

export function rejectEndorsement(endorsementID: string): Promise<ApiResponse<null>> {
    return apiPut<null>(`/api/endorsements/${endorsementID}/reject`, {});
}

export function approvePendingBadge(issuedBadgeID: string): Promise<ApiResponse<null>> {
    return apiPost<null>(`/api/endorsements/${issuedBadgeID}/user-approve`, {});
}

export function getNotificationsCount(): Promise<ApiResponse<{ totalCount: number }>> {
    return apiGet<{ totalCount: number }>('/api/endorsements/notifications/count');
}
